import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { DashboardPageRouting } from "app_dashboard/pages/dashboard/dashboard-page.routing";
import { DashboardPageComponent } from "app_dashboard/pages/dashboard/dashboard-page.component";
import { LineGraphModule } from "./components/line-graph/line-graph.module";
import { SearchParameterService } from "app_dashboard/service/search-parameter.service";
import { BarGraphModule } from "./components/bar-graph/bar-graph.module";
import { RotatebarGraphModule } from "./components/rotatebar-graph/rotatebar-graph.module";
import { SunburstGraphModule } from "./components/sunburst-graph/sunburst-graph.module";
import { DashboardResourceModule } from "libraries/service/resources/dashboard/dashboard-resource.module";
import { SearchHeaderModule } from "./components/search-header/search-header.module";
import { DateParserService } from "libraries/service/date/dateParser.service";
import { ShortDateParserService } from "libraries/service/date/shortDateParser.service";
import { LegacyDateParserService } from "libraries/service/date/legacyDateParser.service";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { NumberGraphModule } from "./components/number-graph/number-graph.module";
import { LabelModule } from "libraries/service/label/label.module";
import { MultipleBarGraphModule } from "./components/multiple-bar-graph/multiple-bar-graph.module";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";

@NgModule({
    imports: [
        BarGraphModule,
        CommonModule,
        DashboardPageRouting,
        DashboardResourceModule,
        LabelModule,
        LineGraphModule,
        LocalizedModule,
        MultipleBarGraphModule,
        NotificationModule,
        NumberGraphModule,
        RotatebarGraphModule,
        SearchHeaderModule,
        SunburstGraphModule,
    ],
    declarations: [
        DashboardPageComponent,
    ],
    providers: [
        SearchParameterService,
        DateParserService,
        ShortDateParserService,
        LegacyDateParserService,
        DatePipe,
    ]
})
export class DashboardPageModule {

}
